import { useNavigate } from "react-router-dom";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { useOnAPISuccess } from "../api/useOnAPISuccess";
import { useToastOnAPIError } from "../api/useToastOnAPIError";
import { LOGGED_IN_HOME_PAGE } from "../config";
import { AppPage } from "../utils/AppPage";
import { TeamManage } from "./TeamManage";

export const TeamCreatePage = () => {
  const api = useAPI();
  const { data, state, error, query } = useAPIQuery<"teamPost">({
    apiCall: api.teamPost,
  });
  const navigate = useNavigate();
  useToastOnAPIError({ title: "Unable to create team", error });
  useOnAPISuccess<"teamPost">({
    data,
    state,
    onSuccess: () => {
      navigate(LOGGED_IN_HOME_PAGE);
    },
  });

  return (
    <AppPage title="Create Team">
      <TeamManage
        isLoading={state === "loading"}
        submitButtonText={"create"}
        onSubmit={(p) =>
          query({
            name: p.teamName,
            color: p.teamColor,
            iconColor: p.iconColor,
            iconType: p.teamIcon,
          })
        }
      />
    </AppPage>
  );
};
